import { screen } from '@tumelo/designsystem'
import { css } from 'styled-components'

export interface LargeUpStyleProps {
  $withMaxWidth?: boolean
}

export const largeUpStyle = (props: LargeUpStyleProps) => css`
  @media ${screen.largeUp} {
    padding: 5.6rem;

    ${
      props.$withMaxWidth &&
      css`
        margin: 0 auto;
        max-width: 83rem; // 718px + padding
      `
    }
  }
`
